import { motion } from "framer-motion";
import {
  Camera,
  Film,
  ShieldCheck,
  Compass,
  Globe,
  Handshake,
} from "lucide-react";
import { useT } from "@/i18n/I18nContext";

const ICONS = [Camera, Film, ShieldCheck, Compass, Globe, Handshake];

export default function WhyBrands() {
  const { t } = useT();
  const cards = t("why.cards");

  return (
    <section
      id="porque"
      data-testid="why-section"
      className="tt-section relative tt-noise"
      style={{ background: "var(--tt-surface)" }}
    >
      <div className="mx-auto max-w-[1480px] px-6 md:px-12">
        <div className="max-w-2xl mb-16">
          <p className="tt-overline">{t("why.overline")}</p>
          <h2 className="mt-4 font-serif text-4xl md:text-6xl leading-[1.02] text-[var(--tt-text)]">
            {t("why.heading_1")}{" "}
            <em className="italic text-[var(--tt-gold)]">{t("why.heading_2")}</em>?
          </h2>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-px bg-[var(--tt-border)] rounded-sm overflow-hidden">
          {cards.map((c, i) => {
            const Icon = ICONS[i] || Camera;
            const code = String(i + 1).padStart(2, "0");
            return (
              <motion.article
                key={code}
                data-testid={`why-card-${code}`}
                initial={{ opacity: 0, y: 24 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true, margin: "-60px" }}
                transition={{ duration: 0.7, delay: i * 0.05 }}
                className="group relative bg-[var(--tt-bg)] p-8 md:p-10 transition-colors duration-500 hover:bg-[var(--tt-surface-2)]"
              >
                <div className="flex items-center justify-between">
                  <span
                    className="w-12 h-12 rounded-full grid place-items-center border transition-all duration-500 group-hover:scale-110"
                    style={{
                      borderColor: "var(--tt-border-strong)",
                      background: "rgba(230,223,211,0.03)",
                    }}
                  >
                    <Icon size={20} className="text-[var(--tt-gold)]" strokeWidth={1.4} />
                  </span>
                  <span className="tt-overline text-[10px] text-[var(--tt-text-muted)]">
                    {code}
                  </span>
                </div>
                <h3 className="mt-8 font-serif text-2xl md:text-3xl text-[var(--tt-text)] leading-tight">
                  {c.title}
                </h3>
                <p className="mt-4 text-[var(--tt-text-dim)] font-light leading-relaxed text-sm md:text-base">
                  {c.desc}
                </p>
              </motion.article>
            );
          })}
        </div>
      </div>
    </section>
  );
}
